module.exports = __webpack_public_path__ + "img/1.6b6ddb84.jpg";